import { render } from "./Department.vue?vue&type=template&id=0e152a2b&scoped=true"
import script from "./Department.vue?vue&type=script&lang=ts"
export * from "./Department.vue?vue&type=script&lang=ts"

import "./Department.vue?vue&type=style&index=0&id=0e152a2b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e152a2b"

export default script